<template>
  <ItemsLister v-bind="itemsListerConfig" :itemsListHelpers="playersListHelpers" />
</template>

<script lang="ts" setup>
import ItemsLister from '@/components/ListingPages/ItemsLister/ItemsLister.vue';
import useItemsListHelpers from '@/components/ListingPages/ItemsLister/composables/itemsListHelpers/itemsListHelpers';
import itemsListerConfig from '@/views/PlayersListView/PlayersLister/config/itemsLister.config';

const props = defineProps(["filters"]);

const tagFilters = props.filters.playerTags.reduce((acc: any, tag: any) => {
  // console.log({ tag });
  const [name, value] = tag.id.split(":");
  // console.log({name, value})
  const filterKey = `FILTER_METADATA_${name.toLowerCase()}`;
  const filterValue = `${value.toLowerCase()}\u0000${name.toLowerCase()}`;

  if(acc[filterKey]) {
    acc[filterKey].push(filterValue)
  } else {
    acc[filterKey] = [filterValue]
  }
  return acc;
}, {});

const organizationsFilter = props.filters.organizations.length 
  ? { "FILTER_ORGANIZATION": props.filters.organizations.map((organization: any) => String(organization.id)) }
  : {};

const locationFilter = props.filters.locations.length
  ? { "FILTER_LOCATION": props.filters.locations.map((location: any) => String(location.id)) }
  : {};

const orientationFilter = props.filters.orientations.length
  ? { "FILTER_ORIENTATION": props.filters.orientations.map((orientation: any) => String(orientation.id)) }
  : {};

const filtersOverride = {
  ...organizationsFilter,
  ...locationFilter,
  ...orientationFilter,
  ...tagFilters,
  "FILTER_OPTION_METADATA": ["OR"]
}

const playersListHelpers = usePlayersListHelpers();

// ---------- Inline Composables ----------
function usePlayersListHelpers() {
  const {
    apiPathsConfig,
    filtersDisplayConfig,
    isEnableAllLimitOption,
    entityItemsNamePlural,
    entityItemName
  } = itemsListerConfig;
  return useItemsListHelpers({
    apiPathsConfig,
    filtersDisplayConfig,
    entityItemsNamePlural,
    entityItemName,
    sortsConfigOverride: {
      fieldName: "DateLastModified",
      isDescending: true
    },
    filtersOverride
  })
}
</script>

<style lang="scss" scoped>
</style>